module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0028.jpg?v=5fe8c0f3";